// extracted by mini-css-extract-plugin
module.exports = {"attributeDad":"EditNftConfigForm_attributeDad__3m754","attribute":"EditNftConfigForm_attribute__lIsH5"};